import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	left: 50%;
	top: 50%;
	width: 500px;
	height: 600px;
	border-radius: 12px;
	transform: translate(-50%, -50%);
	background-color: rgba(0, 0, 0, 0.9);
`;

export { StyledContainer as PanelContainer };
